import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  editProfileSuccess: false,
  error: null,
}

const slice = createSlice({
  name: 'editProfile',
  initialState: initialState,
  reducers: {
    editProfileAction: (state) => {
      state.loading = true
      state.error = null
      state.editProfileSuccess = false
    },
    editProfileSuccessAction: (state)=>{
      state.loading = true
      state.editProfileSuccess = true
      state.error = null
    },
    editProfileErrorAction: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.editProfileSuccess = false
    },
    retrieveUserDataAction: (state) => {
      state.loading = true
      state.error = null
      state.editProfileSuccess = false
    },
    editProfileSetLoadingAction: (state) => {
      state.loading = false
      state.error = null
      state.editProfileSuccess = false
    },
    editProfileResetState: () => initialState,
  },
});

export const {
  editProfileAction,
  editProfileSuccessAction,
  editProfileErrorAction,
  retrieveUserDataAction,
  editProfileSetLoadingAction,
  editProfileResetState
} = slice.actions

export default slice.reducer
